import axios from 'axios';

const popularProductsApi = async (paramsFilter, token, langIsoCode) => {
  try {
    const url = `/publicProducts/popular?page=${paramsFilter?.page || 1}`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default popularProductsApi;
